import {Search} from '@mui/icons-material';
import {Box, debounce, OutlinedInput} from '@mui/material';
import {ChangeEvent, FC} from 'react';
import {useIntl} from 'react-intl';
import {searchInputSx, toolbarActionsSx as actionsWrapperSx} from 'src/components/tables/tableToolbar.sx';
import {EmployeesTableActionsType} from './EmployeesTableAction.types';

export const EmployeesTableAction: FC<EmployeesTableActionsType> = ({
                                                                        handleSearch,
                                                                        searchValue,
                                                                        setSearchValue,
                                                                    }) => {
    const intl = useIntl();

    const handleSearchFieldChange = (
        event: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>
    ): void => {
        setSearchValue(event.target.value);

        debounce(() => {
            handleSearch(event.target.value);
        }, 1000)();
    };

    return (
        <Box sx={actionsWrapperSx}>
            <OutlinedInput
                sx={searchInputSx}
                color="secondary"
                type="text"
                placeholder={intl.formatMessage({id: 'search'})}
                name="search"
                onChange={handleSearchFieldChange}
                startAdornment={<Search/>}
                value={searchValue}
            />
        </Box>
    );
};
